/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_New_PlanInputs */

const en_brand_new_plan = /** @type {(inputs: Brand_New_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first plan`)
};

const id_brand_new_plan = /** @type {(inputs: Brand_New_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat rencana pertama`)
};

/**
* | output |
* | --- |
* | "Create your first plan" |
*
* @param {Brand_New_PlanInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const brand_new_plan = /** @type {((inputs?: Brand_New_PlanInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_New_PlanInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brand_new_plan(inputs)
	return en_brand_new_plan(inputs)
});